import { memo } from "react";

import { AnalyticsPagePersonal } from "hooks/useAnalytics/pages/personal";
import TableCellSpace from "ds/components/Table/Row/CellSpace";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import Box from "ds/components/Box";

import { type RenderGroupRowCellProps } from ".";
import PersonalSettingsSpacesGroupCell from "../Cell";
import { isSpaceActionsGroup } from "../../../helpers";

const PersonalSettingsSpacesTableGroupRowCellSpace = memo((props: RenderGroupRowCellProps) => {
  const { row } = props;

  const spaceId = isSpaceActionsGroup(row) ? row.spaceID : undefined;
  const spaceName = isSpaceActionsGroup(row) ? row.spaceName : undefined;

  return (
    <PersonalSettingsSpacesGroupCell {...props} role="rowheader">
      {spaceId ? (
        <Box>
          <TableCellSpace
            href={`/spaces/${spaceId}`}
            analyticsPage={AnalyticsPagePersonal.PersonalSpaces}
            analyticsTitle="Space name link clicked"
            analyticsProps={{ name: spaceName }}
          >
            {spaceName}
          </TableCellSpace>
        </Box>
      ) : (
        <TableCellEmpty />
      )}
    </PersonalSettingsSpacesGroupCell>
  );
});

PersonalSettingsSpacesTableGroupRowCellSpace.displayName =
  "PersonalSettingsSpacesTableGroupRowCellSpace";

export default PersonalSettingsSpacesTableGroupRowCellSpace;
